module.exports = __webpack_public_path__ + "static/media/al.a4b34f80.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/al.svg
// module id = 2032
// module chunks = 0